/* eslint-disable react/prop-types */
import * as React from 'react';

export const CalendarBold = ({ size = 24, color = '#64748B' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.52617 11.025C3.41571 11.025 3.32617 11.1145 3.32617 11.225V16.865C3.32617 19.845 5.11617 21.625 8.11617 21.625H15.7362C18.7362 21.625 20.5262 19.875 20.5262 16.935V11.225C20.5262 11.1145 20.4367 11.025 20.3262 11.025H3.52617ZM19.2962 5.325C18.5662 4.605 17.5362 4.195 16.3162 4.085V3.125C16.3162 2.715 15.9762 2.375 15.5662 2.375C15.1462 2.375 14.8162 2.715 14.8162 3.125V6.675C14.7462 6.695 14.6862 6.715 14.6162 6.715C14.1962 6.715 13.8662 6.375 13.8662 5.965V4.245C13.8662 4.13454 13.7767 4.045 13.6662 4.045H9.03616V3.125C9.03616 2.715 8.70617 2.375 8.28617 2.375C7.87617 2.375 7.53617 2.715 7.53617 3.125V6.675C7.47617 6.695 7.40617 6.715 7.33617 6.715C6.92617 6.715 6.58617 6.375 6.58617 5.965V4.50055C6.58617 4.37063 6.4638 4.27513 6.33935 4.31245C4.43063 4.88473 3.32617 6.43211 3.32617 8.725V9.325C3.32617 9.43546 3.41571 9.525 3.52617 9.525H20.3262C20.4367 9.525 20.5262 9.43546 20.5262 9.325V8.725C20.5262 7.315 20.1062 6.135 19.2962 5.325Z"
      fill={color}
    />
  </svg>
);
